export const DEFAULT_GEOLOCATION_OPTIONS = {
  enableHighAccuracy: false,
  timeout: 5000,
  maximumAge: Infinity
};

export const DEFAULT_MAP_COORDINATES = {
  /**
   * Canada longitude
   */
  LONG: -96.3468,
  /**
   * Canada latitude
   */
  LAT: 63.1304
};

/**
 * Default zoom level for google map
 * if user had granted geolocation or has visited info from previous searches
 */
export const DEFAULT_ZOOM_LEVEL = 5;

/**
 * Furthest zoomed-out level supported by the map.
 */
export const MINIMUM_MAP_ZOOM_LEVEL = 3;

/**
 * Default interval time for check if user granted/denied geolocation
 */
export const GEOLOCATION_PERMISSION_INTERVAL = 1500;
